import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import "../../../css/Pages.css";
import CopyBtn from '../../Dashboard/Components/CopyBtn';

function AbonnementCollapsible(props) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const abonnement = props.abonnement;
  const klant = props.klant;
  const showInactiveInterfaces = props.showInactiveInterfaces;
  const interfaces = abonnement.interfaces || [];
  const history = useHistory();

  const handleUpdateAbonnement = (e) => {
    e.stopPropagation();
    history.push({
      pathname: "/Abonnementtoevoegen",
      state: { selectedAbonnement: abonnement, klantObject: klant },
    });
  };

  const handleInterfaceClick = (interfaceObj) => {
    history.push({
      pathname: "/Interfacetoevoegen",
      state: {
        klantObject: klant,
        selectedInterface: interfaceObj,
        abonnement: abonnement,
      },
    });
  };

  return (
    <>
      <tr className="subscription-row" onClick={() => setIsOpen(!isOpen)}>
        <td>
          <span className="subscription-toggle">
            <span className="subscription-toggle-icon">{isOpen ? "▼" : "▶"}</span>
            {abonnement.abonnementType?.naam}
          </span>
        </td>
        <td>{abonnement.startdatum ? abonnement.startdatum.toString().split("T")[0] : "-"}</td>
        <td>{abonnement.einddatum ? abonnement.einddatum.toString().split("T")[0] : "-"}</td>
        <td>{abonnement.status}</td>
        <td>{interfaces.length}</td>
        <td>
          <button className="btn btn-secondary" onClick={handleUpdateAbonnement}>
            {t('common.edit')}
          </button>
        </td>
        <td></td>
        <td></td>
      </tr>

      {isOpen && interfaces.length > 0 && (
        <>
          <tr className="interface-header-row">
            <td>{t('interface.title')}</td>
            <td>{t('subscriptions.startDate')}</td>
            <td>{t('subscriptions.endDate')}</td>
            <td>{t('interface.sender')}</td>
            <td>{t('interface.receiver')}</td>
            <td>{t('subscriptions.status')}</td>
            <td>{t('interface.cpAgent')}</td>
            <td>Id</td>
          </tr>
          {interfaces.map((interfaceObj) => {
            if(interfaceObj.status === "Inactief" && (!showInactiveInterfaces)) return null;
            return (
            <tr
              key={interfaceObj.id}
              className="interface-row"
              onClick={() => handleInterfaceClick(interfaceObj)}
            >
              <td>{interfaceObj.artiOms}</td>
              <td>{interfaceObj.startdatum ? interfaceObj.startdatum.toString().split("T")[0] : "-"}</td>
              <td>{interfaceObj.einddatum ? interfaceObj.einddatum.toString().split("T")[0] : "-"}</td>
              <td>{interfaceObj.mkg_relaNr_verzend}</td>
              <td>{interfaceObj.mkg_relaNr_ontvangt}</td>
              <td>{interfaceObj.status}</td>
              <td>{interfaceObj.cp_agent}</td>
              <td>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    flexWrap: "wrap",
                    maxWidth: "100%",
                  }}
                >
                  <div>{interfaceObj.id}</div>
                  <CopyBtn text={interfaceObj.id}/>
                </div>
              </td>
            </tr>
          );})}
        </>
      )}

      {isOpen && interfaces.length === 0 && (
        <tr className="empty-row">
          <td colSpan="8">{t('interface.interfaces')} - {t('common.noDataAvailable')}</td>
        </tr>
      )}
    </>
  );
}

export default AbonnementCollapsible;
